
import React from "react";

export const KnowledgeRatingInfo = () => {
  return (
    <div className="text-sm">
      <div className="border-b border-gray-200 pb-2 mb-3">
        <h3 className="text-lg font-semibold text-red-500 flex items-center gap-2">
          <span className="inline-block">📌</span> 
          มิติที่ 1: ความรู้ (Knowledge) ตาม Bloom's Taxonomy
        </h3>
        <p className="text-gray-600 mt-1">วัดจาก: ระดับความเข้าใจเนื้อหาวิชา / การตอบคำถาม / การอธิบายแนวคิด</p>
      </div>

      <div className="space-y-4">
        {/* 5 คะแนน */}
        <div>
          <h4 className="font-semibold">5 คะแนน = ระดับเชี่ยวชาญ (Mastery)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ตอบคำถามได้ ถูกต้อง 90%+ (ทั้งในคลาสและแบบฝึกหัด)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>อธิบายแนวคิดได้เองโดย ไม่ต้องพึ่งครู</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>สามารถเชื่อมโยงแนวคิดกับเนื้อหาอื่นหรือของเดิมได้ แม้ยาก</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>วิเคราะห์ความแตกต่างของแนวคิด/สูตร/หลักการได้</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>สามารถอธิบายว่า "ทำไม" คำตอบถึงเป็นเช่นนั้น</span>
            </li>
          </ul>
        </div>

        {/* 4 คะแนน */}
        <div>
          <h4 className="font-semibold">4 คะแนน = ระดับเข้าใจดี (Proficient)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ตอบคำถามได้ ถูกต้อง 70-89%</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>อธิบายแนวคิดได้ แต่ยังต้องการคำแนะนำจากครูบ้าง</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>เชื่อมโยงความรู้กับสถานการณ์จริงได้ดี แต่ยังมีจุดที่ไม่มั่นใจ</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>สามารถนำความรู้ไป ประยุกต์ใช้ กับโจทย์ใหม่ที่ไม่เคยเจอมาก่อนได้</span>
            </li>
          </ul>
        </div>

        {/* 3 คะแนน */}
        <div>
          <h4 className="font-semibold">3 คะแนน = ระดับปานกลาง (Developing)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ตอบคำถามได้ ถูกต้อง 50-69%</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>เข้าใจแนวคิดพื้นฐาน แต่ยังอธิบายได้ไม่ชัดเจน</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ทำแบบฝึกหัดบางข้อได้ แต่ยังต้องให้ครูช่วย</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>เข้าใจคำศัพท์/หลักการที่เกี่ยวข้อง แต่ยังเชื่อมโยงไม่ได้เอง</span>
            </li>
          </ul>
        </div>

        {/* 2 คะแนน */}
        <div>
          <h4 className="font-semibold">2 คะแนน = ระดับต้องปรับปรุง (Emerging)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ตอบคำถามได้ ถูกต้อง 30-49%</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>อธิบายแนวคิดได้เพียงบางส่วน ยังขัดข้อง</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>มีความเข้าใจผิดเกี่ยวกับหลักการสำคัญของบทเรียน</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ต้องให้ครูช่วยสรุปหรือชี้แนะแนวทางก่อนจึงจะเข้าใจ</span>
            </li>
          </ul>
        </div>

        {/* 1 คะแนน */}
        <div>
          <h4 className="font-semibold">1 คะแนน = ระดับยังไม่เข้าใจ (Beginning)</h4>
          <p className="mb-1">พฤติกรรมที่สังเกตได้</p>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ตอบคำถามผิดเกือบทั้งหมด (ต่ำกว่า 30%)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ไม่สามารถอธิบายแนวคิดได้เลย หรืออธิบายผิด</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>จำได้เฉพาะสูตรหรือคำตอบ แต่ไม่เข้าใจหลักการ</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500 flex-shrink-0 mt-0.5">✓</span>
              <span>ต้องการการสอนเสริมอย่างมาก</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeRatingInfo;
